module.exports = __webpack_public_path__ + "static/azer-797ef9f24bf2145dc42f530157549827.jpeg";